import { call, put, takeEvery } from "redux-saga/effects";
import { DO_PAYMENT_POST, DO_PAYMENT_SIGN_VOID,DO_PAYMENT_SIGN_REFUND } from "./actionTypes";
import { doPaymentPostSuccess, doPaymentApiError, doPaymentSignVoidSuccess,doPaymentSignRefundSuccess } from "./actions";
import { doPaymentPost, doPaymentSignVoid, doPaymentSignRefund } from "helpers/backend_helper/backend_helper";

import { toast,Zoom } from "react-toastify";
import i18n from 'i18n';

function* onPostDoPayment({ payload: record }) {
  try {
    const response = yield call(doPaymentPost, record)
    yield put(doPaymentPostSuccess(response))
  } catch (error) {
    yield put(doPaymentApiError(error))
  }
}
function* onSignVoidDoPayment({ payload: record }) {
  try {
    const response = yield call(doPaymentSignVoid,record)
    yield put(doPaymentSignVoidSuccess(response))
  } catch (error) {
    yield put(doPaymentApiError(error))
  }
}
function* onSignRefundDoPayment({ payload: record }) {
  try {
    const response = yield call(doPaymentSignRefund,record)
    yield put(doPaymentSignRefundSuccess(response))
  } catch (error) {
    yield put(doPaymentApiError(error))
  }
}


function* doPaymentSaga() {
  yield takeEvery(DO_PAYMENT_POST, onPostDoPayment)
  yield takeEvery(DO_PAYMENT_SIGN_VOID, onSignVoidDoPayment)
  yield takeEvery(DO_PAYMENT_SIGN_REFUND,onSignRefundDoPayment)
}
export default doPaymentSaga
